var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paragraph)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.paragraph.html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }